import { useGetPath } from '@hooks/interview/useGetPath';
import { useMeetingSession } from '@hooks/meeting/useMeetingSession';
import { useBrowser } from '@hooks/utils/useBrowser';
import { useMeetingManager } from '@providers/MeetingProvider';
import { useEffect, type FC } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { Container, TestSettingLayout } from './style';

const SettingLayout: FC = () => {
  const navigate = useNavigate();
  const meetingManager = useMeetingManager();
  const { initializeTester } = useMeetingSession(meetingManager);
  const { browserHelper } = useBrowser();
  const { rootPath } = useGetPath();

  const handleError = (error?: unknown) => {
    console.log(error);
    alert('인증 실패');
    navigate('/error', { replace: true });
  };

  const initSession = async () => {
    if (!browserHelper.checkChromeBrowser())
      return navigate(rootPath.CHECK_BROWSER, {
        replace: true,
      });

    try {
      const isTesterInit = await initializeTester();
      if (!isTesterInit)
        return handleError('인터뷰 생성실패, 고객센터에 문의하세요.');
    } catch (error) {
      return handleError(error);
    }
  };

  useEffect(() => {
    (async () => await initSession())();
  }, []);

  return (
    <TestSettingLayout>
      <Container>
        <Outlet />
      </Container>
    </TestSettingLayout>
  );
};

export default SettingLayout;
